import type { PropsWithChildren } from 'react';
import { NavbarMenuListV2Context } from './context';

type Props = PropsWithChildren<{
  justify: string;
}>;

export function NavbarMenuListV2Provider({ children, justify }: Props) {
  return <NavbarMenuListV2Context.Provider value={{ justify }}>{children}</NavbarMenuListV2Context.Provider>;
}
